import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode } from "vue"


import { ref, defineComponent, onMounted, defineProps } from 'vue'
import { ElMessage, ElTree } from 'element-plus'
import { apiPostData, apiFetchData, MenuTree, isEmptyString, getI18n, i18nTreeData, parseResponse } from '../../utils'
import { apiAdminLoadRolePath, apiAdminSaveRoleMenusPath } from '../../config'

// 解决vs中的语法错误提示
const __default__ = defineComponent({
  name: 'EditMenuPage'
})

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  item: {
    type: Object,
    required: true
  }
},
  setup(__props) {

const props = __props

const defaultProps = {
  children: 'children',
  label: 'label'
}

const saveMenuPrivilege = (succesPopMessage:boolean) => {
  if (currentIndex < 0) {
    // 还没有选择任何节点
    return
  }
  if (refRoleList.value.length === 0) {
    return
  }
  const id = refRoleList.value[currentIndex].id
  refRoleList.value[currentIndex].roleMenus = treeRef.value ? treeRef.value.getCheckedKeys(false) : []
  const roleMenus = JSON.stringify(refRoleList.value[currentIndex].roleMenus)
  const postData = { roleMenus: roleMenus, id: id }
  console.log('postData=', postData)
  apiPostData(apiAdminSaveRoleMenusPath, postData)
    .then(data => {
      console.log('handleCheckChange data=', data)
      const result = parseResponse(data)
      if ((succesPopMessage && result.success) || !result.success) {
        ElMessage({
          type: result.success ? 'success' : 'error',
          message: data.success ? '保存成功' : '保存失败:' + result.message
        })
      }
    })
}

const refRoleList = ref([])
let currentIndex = -1

const handleCheckChange = (
  data: MenuTree,
  checked: boolean,
  indeterminate: boolean
) => {
  console.log(data, checked, indeterminate)
}

function selectRole (index) {
  if (refRoleList.value.length === 0) {
    return
  }
  if (!('roleMenus' in refRoleList.value[index])) {
    if (!isEmptyString(refRoleList.value[index].role_menus)) {
      refRoleList.value[index].roleMenus = JSON.parse(refRoleList.value[index].role_menus)
    } else {
      refRoleList.value[index].roleMenus = []
    }
  }
  // 把之前的先保存一下
  saveMenuPrivilege(false)
  currentIndex = index
  for (let i = 0; i < refRoleList.value.length; i++) {
    refRoleList.value[i].selected = i === index
  }
  treeRef.value.setCheckedKeys(refRoleList.value[index].roleMenus, false)
}
// 菜单树的数据，
const refTreeData = ref([] as MenuTree[])
const treeRef = ref<InstanceType<typeof ElTree>>()

// 重新组织菜单树
function structMenu () {
  const mainMenus = [] as MenuTree[]
  i18nTreeData(props.item.data)
  for (let i = 0, j = 0; i < props.item.data.length; i++) {
    if (props.item.data[i].tag === 'menu-placeholder') {
      continue
    }
    mainMenus[j] = props.item.data[i]
    j++
  }
  refTreeData.value = mainMenus
}
onMounted(async () => {
  try {
    console.log(props.item.data)
    console.log('EditMenuPage onMouted')
    const data = await apiFetchData(apiAdminLoadRolePath)
    refRoleList.value = data.data
    structMenu()
  } catch (error) {
    console.error(error)
  }
})

return (_ctx: any,_cache: any) => {
  const _component_el_text = _resolveComponent("el-text")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_row = _resolveComponent("el-row")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_row, {
      id: "menu-tree",
      gutter: 12,
      class: "demo-radius"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_col, {
          span: 8,
          xs: { span: 12 }
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_text, {
              class: "mx-1",
              type: "primary"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(getI18n)('角色')), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_col, {
          span: 14,
          xs: { span: 12 }
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, { span: 18 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_text, {
                      class: "mx-1",
                      type: "primary"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(getI18n)('菜单')), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, {
                  span: 6,
                  align: "right"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_button, {
                      type: "primary",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (saveMenuPrivilege(true)))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(getI18n)('保存')), 1)
                      ]),
                      _: 1
                    }),
                    _createTextVNode("   ")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_el_row, {
      gutter: 12,
      class: "demo-radius"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_col, {
          span: 8,
          xs: { span: 12 }
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", {
              class: "radius",
              style: _normalizeStyle(`var(--el-border-radius-base)`)
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(refRoleList.value, (item, index) => {
                return (_openBlock(), _createElementBlock("div", { key: item }, [
                  _createVNode(_component_el_text, {
                    class: _normalizeClass(["mx-1 text_center box", {'selected-box': item['selected'] }]),
                    onClick: ($event: any) => (selectRole(index))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(getI18n)(item.role_name)), 1)
                    ]),
                    _: 2
                  }, 1032, ["class", "onClick"])
                ]))
              }), 128))
            ], 4)
          ]),
          _: 1
        }),
        _createVNode(_component_el_col, {
          span: 14,
          xs: { span: 12 }
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", {
              class: "radius",
              style: _normalizeStyle(`var(--el-border-radius-base)`)
            }, [
              _createVNode(_unref(ElTree), {
                data: refTreeData.value,
                "node-key": "id",
                "show-checkbox": "",
                ref_key: "treeRef",
                ref: treeRef,
                props: defaultProps,
                onCheckChange: handleCheckChange
              }, null, 8, ["data"])
            ], 4)
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ], 64))
}
}

})